<template>
    <DashView>
        <div class="container-fluid pt-4 px-4">
            <div class="row g-4">
                <!-- Column -->
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-body">
                            <div>
                                <!-- Header -->
                                <header class="app-header py-2 ">
                                    <div class="container-fluid">
                                        <!-- -----------Impression--------------- -->
                                        
                                        <div class="invoice-box" hidden>
                                            <div class="d-flex justify-content-between invoice-header">
                                                <div>
                                                    <h1 class="invoice-title">Facture</h1>
                                                    <div v-if="entreprise?.nom"><strong>{{ entreprise?.nom }}</strong><br>
                                                        <br>
                                                        <p v-if="entreprise?.adresse">{{ entreprise?.adresse }}</p><br>
                                                        <p v-if="entreprise?.email">{{ entreprise?.email }}</p>
                                                    </div>
                                                    <div>
                                                        <!-- <img src="https://via.placeholder.com/120x70?text=Logo" alt="Logo Clinique" class="clinic-logo mb-2"> -->
                                                        <p>
                                                        <strong>Date :</strong> {{ dateDuJour }}
                                                        </p>
                                                    </div>
                                                </div>

                                            <div class="mb-4">
                                                <div class="col-md-6">
                                                    <p><strong># Facture:</strong> {{ this.code }} </p>
                                                </div>
                                                <h5>Informations du Patient</h5>
                                                <div class="row">
                                                    <div class="col-md-6" v-if="facture.length>0">
                                                        <p><strong>Nom Complet :</strong> {{ facture?.patient?.nom }} {{ facture?.patient?.prenom }}<br>
                                                        <strong>Dossier Patient :</strong> {{ facture?.patient?.code_dossier }}<br>
                                                        <strong>Sexe :</strong> {{ facture?.patient?.sexe=== 1 ? 'Masculin' : 'Féminin' }}</p>
                                                    </div>                                            
                                                </div>                                            
            

                                                <p class="mt-3"><strong>Note :</strong> Merci! Pour toute question, veuillez contacter le secrétariat.</p>

                                                <div class="text-center mt-3 mb-5 pb-5 no-print">
                                                    <button @click="registerFacture" class="btn btn-primary me-2" v-if="save==false">
                                                        <i class="fa fa-save text-white"></i> Enrégistrer
                                                    </button>
                                                    
                                                </div>

                                            </div>
                                            <!-- ------------------------------- -->
                                        <div class="d-flex align-items-center justify-content-between">
                                            <div class="d-flex align-items-center gap-3">
                                            <i class="bi bi-hospital fs-3 text-primary"></i>
                                            <div>
                                                <h1 class="h5 mb-0 no-print">Encaissement Facture Patient</h1>
                                                <!-- <small class="text-muted">Caissier(ère): <span id="cashierName">—</span></small> -->
                                            </div>
                                            </div>
                                            <div class="row g-2 align-items-end">
                                                    <div class="col-12 col-md-12">
                                                        <label class="form-label">Numéro de facture</label>
                                                        <div class="input-group">
                                                            <span class="input-group-text"><i class="bi bi-receipt"></i></span>
                                                            <input type="text" id="invoiceNumber" class="form-control" placeholder="Saisir numéro facture..." v-model="code" @keydown.enter.prevent="getFacture">
                                                            <button class="btn btn-primary" id="btnSearch"><i class="bi bi-search" @click="getFacture"></i></button>
                                                        </div>
                                                    </div>
                                                </div>
                                        </div>
                                        </div>
                                     </div>

                                        <!-- Div Print Bureau begin-->
                                        <div style="text-align:center; color:black;" id="divToPrintBureau" class="d-none hidden col-md-12 col-sm-12">
                                                
                                                <div class="row">
                                                    <div class="block" style="float:left;width:50%;box-sizing: border-box;padding: 15px;">
                                                        Facture: <strong>{{facture.number}}</strong> <br>
                                                        Séquence: <strong>{{facture.sequence}}</strong> <br>
                                                        Date Facture: <strong :title="facture.dateFacture">{{ formatDate(facture.dateFacture)}}</strong> <br>
                                                        <!-- : {{facture.vendeur}}<br> -->
                                                        <small> <strong>Date du jour :</strong> {{ dateDuJour }}</small>
                                                    </div>
                                                    <div class="block" style="float:left;width:50%;box-sizing: border-box;padding: 15px;">
                                                        
                                                        <strong>Patient</strong><br>
                                                        {{ facture?.patient?.nom }} {{ facture?.patient?.prenom }}<br>
                                                    {{ facture?.patient?.code_dossier }}<br>
                                                    <!-- {{ facture?.patient?.sexe=== 1 ? 'Masculin' : 'Féminin' }} -->
                                                        
                                                    </div>
                                                    
                                                </div>
                                                <br>
                                                <div class="col-md-12 col-sm-12">
                                                    <table v-if="facture?.details?.length>0" class="hidden d-none col-md-12 col-sm-12 table--ben responsive" width="100%" style="border-collapse:collapse; border:1px solid black;" >
                                                        <thead>
                                                            <tr>
                                                                <th style="text-align:left;border: 1px solid black; width: 40%;">Service</th>
                                                                <th style="text-align:center;border: 1px solid black; width: 20%;">Qté</th>
                                                                <th style="text-align:center;border: 1px solid black; width: 20%;">Prix unité</th>
                                                                <th style="text-align:right;border: 1px solid black; width: 20%;">Prix Total</th>
                                                            </tr>
                                                        </thead>
                                                        </table>
                                                        <div style="border: 1px solid black; height: 300px;">
                                                                    <table class="hidden d-none col-md-12 col-sm-12 responsive" width="100%">
                                                                        <tbody class="" style="border: 1px solid black;">
                                                                            <tr v-for="(details,key) in facture.details" :key="key">
                                                                                <td style="text-align:left; width: 40%;">{{ details.service.service}}</td>
                                                                                <td style="text-align:center; width: 20%;">{{ details.quantite }}</td>
                                                                                <td style="text-align:center; width: 20%;">{{ details.prix_unitaire }}</td>                                                              
                                                                                <td style="text-align:right; width: 20%;">{{ details.prix_total}} </td>                                                              
                                                                            </tr>  
                                                                        </tbody>
                                                                    </table>
                                                            </div>
                                                    <br/>
                                                    <table style="float: right; border: 1px solid black; padding:15px;">
                                                        <tfoot>
                                                            <tr>
                                                                <th style="text-align: right;">Sub Total:</th>
                                                                <th style="text-align: right;">{{ facture.sousTotal }} {{ facture.indice }}</th>
                                                            </tr>
                                                            <tr>
                                                                <th style="text-align: right;">Rabais:</th>
                                                                <th style="text-align: right;">{{ facture.rabais }} {{ facture.indice }}</th>
                                                            </tr>
                                                            <!-- <tr>
                                                                <th style="text-align: right;">Total:</th>
                                                                <th style="text-align: right;">HTG {{ facture.totalApayer }}</th>
                                                            </tr> -->
                                                            <!-- <tr>
                                                                <th style="text-align: right;">TCA:</th>
                                                                <th style="text-align: right;">{{ facture.taxe }} {{devizSystem}}</th>
                                                            </tr> -->
                                                            <tr>
                                                                <th style="text-align: right;">GTotal:</th>
                                                                <th style="text-align: right;">{{ facture.totalApayer }} {{ facture.indice }}</th>
                                                            </tr>
                                                            <tr>
                                                                <th style="text-align: right;">Montant Offert:</th>
                                                                <th style="text-align: right;">{{ facture.somme_entrer }} {{facture.indice}}</th>
                                                            </tr>
                                                            <tr>
                                                                <th style="text-align: right;">{{(facture.balance>=0?"Balance":"Monnaie")}}:</th>
                                                                <th style="text-align: right;">{{ facture.balance }} {{ facture.indice }}</th>
                                                            </tr>
                                                        </tfoot>
                                                    </table>                                            
                                                </div>
                                                <!-- <div v-else class="alert alert-info text-info text-center">Aucun élément</div> -->
                                                <br>
                                                <!-- <NoteFiche :notes="notes" v-if="notes.length>0"/> -->
                                                
                                                    
                                        </div>
                                    <!-- Div Print Bureau End -->

                                    <!-- Div Print Thermal begin-->
                                    <div style="color:black; width: 100%; padding-right: 2%;" id="divToPrintThermale" class="d-none hidden col-md-12 col-sm-12">
                                            <div class="row">
                                                <div class="block" style="float:left;width:80%;box-sizing: border-box;">
                                                    <p>#: {{facture.number}}</p>
                                                    <p>Date Facture: <strong :title="facture.dateFacture">{{ formatDate(facture.dateFacture)}}</strong> </p>
                                                    <p><small> <strong>Date du jour :</strong> {{ dateDuJour }}</small><br></p>
                                                    <!-- <strong>Vendeur:</strong> {{facture.vendeur}}<br> -->
                                                <strong>Patient</strong><br>
                                                    {{ facture?.patient?.nom }} {{ facture?.patient?.prenom }}<br>
                                                {{ facture?.patient?.code_dossier }}<br>
                                                {{ facture?.patient?.sexe=== 1 ? 'Masculin' : 'Féminin' }}
                                                </div>
                        
                                            </div>
                                            <div class="col-md-12 col-sm-12">
                                                <p style="text-align: center;">************************************* </p>
                                                <div style="display: flex; flex-wrap: nowrap; width: 90%;" v-if="facture?.details?.length>0">
                                                    <div style="text-align:left; width:40%;" >Article</div>
                                                    <div style="text-align:center; width:20%;" >Qté</div>
                                                    <div style="text-align:right; width:20%;" >Prix Uté&nbsp;</div>                                                
                                                    <div style="text-align:right; width:20%;" >Prix Tot.&nbsp;</div>                                                
                                                </div>
                                                <div>

                                                    <!-- <tr v-for="(details,key) in facture.details" :key="key">
                                                            <td style="text-align:left;">{{ details.service.service}}</td>
                                                            <td style="text-align:center;">{{ details.quantite }}</td>
                                                            <td style="text-align:center;">{{ details.prix_unitaire }}</td>                                                              
                                                            <td style="text-align:right;">{{ details.prix_total}} </td>                                                              
                                                    </tr>   -->
                                                    <template v-if="facture?.details?.length>0">
                                                        <div>----------------------------------------</div>
                                                        <div v-for="(details,i) in facture.details" :key="i" style="display: flex; flex-wrap: nowrap; width: 90%;">
                                                            <div style="text-align:left; width:40%; padding: 2px;">{{details.service.service}}</div>
                                                            <div style="text-align:center; width:20%; padding: 2px;">{{details.quantite}}</div>
                                                            <div style="text-align:right; width:20%; padding: 2px;">{{details.prix_unitaire}}</div>                                                              
                                                            <div style="text-align:right; width:20%; padding: 2px;">{{(details.prix_unitaire*details.quantite).toFixed(2)}} </div>                                                              
                                                        </div> 
                                                        <p style="text-align: center;">-------------------------------------</p>
                                                        <br>
                                                    </template>
                                                    
                                                    <p style="text-align: center;">************************************* </p>
                                                    <br>
                                                    
                                                    <div style="text-align: right; width: 100%;">
                                                        <div>
                                                            <div>Sub Total: {{facture.sousTotal}} {{facture?.indice}}&nbsp;</div>
                                                        </div>
                                                        <div>
                                                            <div>Rabais: {{ facture.rabais }} {{facture?.indice}}&nbsp;</div>
                                                        </div>
                                                        <div>
                                                            <div>Total: {{ facture.total }} {{facture?.indice}}&nbsp;</div>
                                                        </div>
                                                        <div>
                                                            <div>TCA: {{ facture.taxe }} {{facture?.indice}}&nbsp;</div>
                                                        </div>
                                                        <div>
                                                            <div>GTotal: {{ facture.totalApayer }} {{facture?.indice}}&nbsp;</div>
                                                        </div>
                                                        <div>
                                                            <div>Offert: {{ facture.somme_entrer }} {{facture?.indice}}&nbsp;</div>
                                                        </div>
                                                        <div>
                                                            <div>{{(facture.balance>=0?"Balance":"Monnaie")}}: {{ facture.balance }} {{facture?.indice}}&nbsp;</div>
                                                        </div>
                                        
                                                    </div>
                                                </div>
                                                <!-- <div v-else class="alert alert-info text-info text-center">Aucun élément</div> -->
                                                
                                            </div>
                                            <br>
                                            
                                            <!-- <NoteFiche :notes="notes" v-if="notes.length>0"/> -->
                                            <br/>
                                            <div style="width:80%; text-align:center;">
                                                <p><small>Merci d'avoir choisi <strong>{{ infoEntreprise?.nom }}</strong> </small></p>
                                            </div>
                                            <br/>
                                            <br/>

                                    </div>
                                    <!-- Div Print Thermal End -->
                                        <!-- -----------Impression--------------- -->
                                        
                                    </div>
                                </header>

                                <main class="container-fluid py-3" v-if="facture?.number">
                                    <div class="row g-3">
                                    <!-- Col gauche: Recherche facture -->
                                    <section class="col-12 col-lg-8">
                                        <div class="card shadow-sm">
                                        <div class="card-body">
                                            <!-- <div class="row g-2 align-items-end">
                                                <div class="col-12 col-md-6">
                                                    <label class="form-label">Numéro de facture</label>
                                                    <div class="input-group">
                                                        <span class="input-group-text"><i class="bi bi-receipt"></i></span>
                                                        <input type="text" id="invoiceNumber" class="form-control" placeholder="Saisir numéro facture...">
                                                        <button class="btn btn-primary" id="btnSearch"><i class="bi bi-search"></i></button>
                                                    </div>
                                                </div>
                                            </div> -->

                                            <!-- Résultats facture -->
                                             
                                            <h6 class="mb-3 text-center">Détails de la facture</h6>
                                            <div id="invoiceDetails" class="mt-4 mb-5">
                                            <p><strong>Numéro Facture :</strong> <span id="patientName">{{ facture?.number }}</span></p>
                                            <p><strong>Patient :</strong> <span id="patientName">{{ facture?.patient?.nom }} {{ facture?.patient?.prenom }}</span></p>
                                            <p><strong>Numéro Dossier :</strong> <span id="numberpatient">{{ facture?.patient.code_dossier }}</span></p>
                                            <p><strong>Sexe :</strong> <span id="sexepatient">{{ facture?.patient?.sexe=== 1 ? 'Masculin' : 'Féminin' }}</span></p>
                                            <p><strong>Téléphone :</strong> <span id="phonepatient">{{ facture.patient.phone }}</span></p>
                                            <p :title="facture.dateFacture"><strong>Date :</strong> <span id="date">{{ formatDate(facture.dateFacture) }}</span></p>
                                            <div class="cart-table-wrap">
                                                    <table class="table table-sm align-middle">
                                                        <thead>
                                                            <tr>
                                                            <th>Service</th>
                                                            <th class="text-end">Qté</th>
                                                            <th class="text-end">Prix</th>
                                                            <th class="text-end">Total</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody id="invoiceItems">
                                                            <tr v-for="(details,key) in facture.details" :key="key">
                                                                <td>{{ details.service.service }}</td>
                                                                <td class="text-end">{{ details.quantite }}</td>
                                                                <td class="text-end">{{ details.prix_unitaire }}</td>
                                                                <td class="text-end">{{ details.prix_total}}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>  
                                                
                                            </div>
                                        </div>
                                        </div>
                                    </section>

                                    <!-- Col droite: Totaux & Paiement -->
                                    <aside class="col-12 col-lg-4">
                                        <div class="card shadow-sm totals-card">
                                        <div class="card-body">
                                            <h2 class="h6 mb-2">Récapitulatif</h2>
                                            <hr/>
                                            <ul class="list-group list-group-flush">
                                                <li class="list-group-item d-flex justify-content-between"><span class="label">Sous-total</span><span class="value" id="grandTotal"> {{ facture.sousTotal }} {{ facture.indice }}</span></li>
                                                <li class="list-group-item d-flex justify-content-between"><span class="label">Rabais</span><span class="value" id="grandTotal"> {{ facture.rabais }} {{ facture.indice }}</span></li>
                                                <li class="list-group-item d-flex justify-content-between"><span class="label">Taxe</span><span class="value" id="grandTotal">{{ facture.taxe }} {{ facture.indice }}</span></li>
                                                <li class="list-group-item d-flex justify-content-between"><span class="label">Montant à payer</span><span class="value" id="grandTotal"> {{ facture.totalApayer }} {{ facture.indice }}</span></li>
                                                <li class="list-group-item d-flex justify-content-between"><span class="label">Montant Offert</span><span class="value" id="somme_entrer"> {{ facture.somme_entrer }} {{ facture.indice }}</span></li>
                                                <li class="list-group-item d-flex justify-content-between"><span class="label">Balance</span><span class="value" id="balance">{{ facture.balance }} {{ facture.indice }}</span></li>
                                            </ul>
                                        </div>
                                        </div>

                                        <div class="card shadow-sm mt-3 mb-5">
                                        <div class="card-body">
                                            <div class="text-info text-center" v-if="success_msg">{{ success_msg }}</div>
                                            <h2 class="h6">Paiement</h2>
                                            <p v-if="status_facture == 2" class="text-info fw-bold text-center">Cette facture est déjà payée !!</p>
                                            <div class="row g-2">
                                            <div class="col-12">
                                                <label class="form-label">Méthode Paiement</label>
                                                <select class="form-control" v-model="caisse.methode" id="paymentMethod">
                                                    <option value="CASH">CASH</option>
                                                    <option value="CARTE DE CREDIT">CARTE DE CREDIT</option>
                                                    <option value="MONCASH">MONCASH</option>
                                                    <option value="NATCASH">NATCASH</option>
                                                    <option value="CHEQUE">CHEQUE</option>
                                                    <option value="CREDIT">CREDIT</option>
                                                    <option value="CASH & CREDIT">CASH & CREDIT</option>
                                                    <option value="VIREMENT BANCAIRE">VIREMENT BANCAIRE</option>
                                                </select>
                                            </div>
                                            <div class="col-12" v-if="['MONCASH','NATCASH','VIREMENT BANCAIRE','CARTE DE CREDIT','CHEQUE'].includes(caisse.methode)">
                                                <label class="form-label">Référence</label>
                                                <input type="text" class="form-control" id="produit" v-model="caisse.reference"/>
                                            </div>
                                            <div class="col-6">
                                                <label class="form-label">Montant Reçu</label>
                                                <div class="input-group">
                                                <span class="input-group-text">HTG</span>
                                                <input type="number" class="form-control" v-model="caisse.montant" id="amountReceived" min="0" step="any" value="0" required>
                                                </div>
                                            </div>
                                            <div class="col-6">
                                                <label class="form-label">Devise</label>
                                                <select class="form-control custom-select text-center" id="commune_patient" v-model="caisse.devisePatient">
                                                    <option value="" disabled>--Devise--</option>
                                                    <template v-if="devises.length > 0">
                                                    <option v-for="(devise,key) in devises" :key="key" :value="devise.id">{{ devise.devise }}</option>
                                                    </template>
                                                    <template v-else>
                                                    <!-- <option value="">Aucune Devise trouvée</option> -->
                                                    </template>
                                                </select>
                                            </div>
                                            <div class="col-6" hidden>
                                                <label class="form-label">Monnaie à rendre</label>
                                               <input type="text" class="form-control" id="changeDue" readonly :value="'HTG ' + (facture.totalApayer-caisse.montant)*(-1)">
                                            </div>
                                            <div class="col-12 d-grid gap-2 mt-2">
                                                <button class="btn btn-success btn-lg" id="btnPay" @click="encaisser" :disabled="facture.status==2 || facture.balance<=0"><i class="bi bi-cash-coin me-1" ></i>Encaisser</button>
                                                <div class="btn-group">
                                                    <button type="button" class="btn btn-outline-secondary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                                        <i class="bi bi-printer me-1"></i>Imprimer le reçu
                                                    </button>
                                                    <ul class="dropdown-menu">
                                                        <li><a class="dropdown-item" href="#" @click="printDivBureau">Format Lettre</a></li>
                                                        <li><a class="dropdown-item" href="#" @click="printDivThermal">Format Thermal</a></li>
                                                    </ul>
                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                        </div>
                                    </aside>
                                    </div>
                                </main>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </DashView>
     <!--Begin All Modal -->
          
        <!-- End All Modal -->
</template>
<script>
import DashView from "@/components/DashView.vue"
import axios from 'axios'
  import $ from 'jquery';
  const base_url=process.env.VUE_APP_API_URL;
export default {
    name:"Payment",
    components:{
        DashView
    },
    data(){
      return{
          facture:[],
          status_facture:'',
          accessToken:JSON.parse(localStorage.getItem('user_zgh')).token ?? '',
          code:'',
          devises:[],
          infoEntreprise:[],
          caisse:{
            methode:'',
            reference:'',
            monnaie:0,
            montant:0,
            devisePatient:0,
            balance:0
          },
        dateDuJour:'',
        success_msg:''

      }
    },
     created(){
        this.Entreprise();
      const aujourdhui = new Date();
      this.dateDuJour = aujourdhui.toLocaleDateString('fr-FR');
      const code = this.$route?.params?.facture;
      this.code = code;
      if(code){
        this.getFacture_(code);
      }
      else{
        this.$router.push('/factures')
      }

    },
    methods:{
        formatDate(dateString) {
            const date = new Date(dateString);
            const day = ('0' + date.getDate()).slice(-2);
            const month = ('0' + (date.getMonth() + 1)).slice(-2);
            const year = date.getFullYear();
            const hours = ('0' + date.getHours()).slice(-2);
            const minutes = ('0' + date.getMinutes()).slice(-2);
            const seconds = ('0' + date.getSeconds()).slice(-2);

            return `${day}-${month}-${year}`;
        },
        getDevises(){ 
            console.log(this.code);
            
            axios.get(`${base_url}/devises`,{
            headers:{
                Accept:'application/json',
                'Content-Type':'application/json;charset=UTF-8',
                Authorization:`Bearer ${this.accessToken}`
            }
        })
            .then((response)=>{
                console.log(response.data);
                if(response.data){
                  this.devises = response.data;
                //   this.devises = this.devises.filter((element)=>element.status==0);
                  console.log(this.devises);
                  
                }
            })
            .catch((error)=>{
            if(error?.response?.status === 403){
                    console.log('NO access');
                    $('#openModalNoAccess').trigger('click');
            }
            else {
            // Gérer d'autres erreurs ici
                console.log('Une erreur est survenue!');
                console.log('Autre erreur:', error);
            }
            })
        },
        getFacture() {
            this.facture=[];
            console.log("Code facture recherché:", this.code);

            axios.get(`${base_url}/search_facture`, {
                params: {
                    number: this.code
                },
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    Authorization: `Bearer ${this.accessToken}`
                }
            })
            .then((response) => {
                console.log(response.data);
                this.facture = response.data;
                this.status_facture = this.facture.status;
                // this.updateModalContent(response.data); // décommenter si tu veux afficher les infos
            })
            .catch((error) => {
                if (error?.response?.status === 403) {
                    // console.warn('Accès refusé');
                    $('#openModalNoAccess').trigger('click');
                } else if (error?.response?.status === 404) {
                    console.warn('Facture non trouvée');
                    // alert('Aucune facture trouvée.');
                } else {
                    console.error('Une erreur est survenue:', error);
                }
            });
        },
        getFacture_(code) {
            this.facture=[];
            this.status_facture='';
            console.log("Code facture recherché:", code);

            axios.get(`${base_url}/search_facture`, {
                params: {
                    number: code
                },
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    Authorization: `Bearer ${this.accessToken}`
                }
            })
            .then((response) => {
                console.log(response.data);
                this.facture = response.data;
                this.status_facture = this.facture.status;
                console.log('status facture: '+this.facture.status);
                
                // this.updateModalContent(response.data); // décommenter si tu veux afficher les infos
            })
            .catch((error) => {
                if (error?.response?.status === 403) {
                    // console.warn('Accès refusé');
                    $('#openModalNoAccess').trigger('click');
                } else if (error?.response?.status === 404) {
                    console.warn('Facture non trouvée');
                    // alert('Aucune facture trouvée.');
                } else {
                    console.error('Une erreur est survenue:', error);
                }
            });
        },
        encaisser(){
            const data = {
                somme_entrer: this.caisse.montant,
                reference: this.caisse.reference,
                methode: this.caisse.methode,
                facture_number : this.facture.number,
                devisePatient:this.caisse.devisePatient,
                deviseSystem:1,
                totalApayer : this.facture.totalApayer,
                taxe:0,
                rabais:0,
                taux:1,
                balance:(this.facture.totalApayer - this.caisse.montant).toFixed(2) >= 0 ? (this.facture.totalApayer - this.caisse.montant).toFixed(2): -1*(this.facture.totalApayer - this.caisse.montant).toFixed(2)
            };
            console.log(data);

            // --------------------------------------------------
          axios.post(`${base_url}/encaisser`,data,{
                headers:{
                    Accept:'application/json',
                    'Content-Type':'application/json;charset=UTF-8',
                    Authorization:`Bearer ${this.accessToken}`
                }
            })
            .then((response)=>{
              console.log('Return data');
              
                console.log(response);
                if(response.status==201){
                    const self= this;
                    setTimeout(function() {
                        location.reload();
                        self.success_msg = `Encaissement enregistrée avec succèss!`;
                    },2000);
                }
            })
.catch((error) => {
    console.log("Erreur Axios complète:", error);
    
    // Si la réponse est disponible
    if (error.response) {
        console.log("Code d'erreur : ", error.response.status);
        
        // Vérifie si la réponse contient un message d'erreur
        if (error.response.data && error.response.data.message) {
            // Si le message existe, l'utiliser
            this.success_msg = error.response.data.message;
        } 
        else {
            // Sinon afficher un message générique
            this.success_msg = "Une erreur est survenue. Veuillez vérifier les informations.";
        }

        // Traitement pour les erreurs 400
        if (error.response.status === 400) {
            // Message spécifique si la facture est déjà payée (par exemple)
            console.log("Cette facture est déjà payée");
            this.success_msg = 'Cette facture est déjà payée';
        }
    } else {
        // Si aucune réponse n'est reçue (problème réseau ou autre)
        console.log("Erreur sans réponse : ", error.message);
        this.success_msg = "Un problème est survenu avec la connexion.";
    }
});



      // --------------------------------------------------
            
        },        
        printDivThermal2() {
            console.log('printDivThermal');
            
            const content = document.getElementById('divToPrintThermale').innerHTML;

            const printWindow = window.open('', '', 'width=380,height=600'); // largeur adaptée au POS 58mm

            printWindow.document.write(`
            <html>
                <head>
                <title>Reçu POS 58mm</title>
                <style>
                    @media print {
                    @page {
                        size: 58mm auto;
                        margin: 5mm;
                    }
                    }
                    body {
                    font-family: monospace;
                    font-size: 10px;
                    line-height: 1.2;
                    margin: 0;
                    padding: 0;
                    width: 58mm;
                    }
                    h1, h5 {
                    font-size: 13px;
                    margin: 4px 0;
                    text-align: center;
                    }
                    p {
                    margin: 2px 0;
                    }
                    img {
                    max-width: 100px;
                    display: block;
                    margin: 0 auto 8px;
                    }
                    hr {
                    border: none;
                    border-top: 1px dashed #000;
                    margin: 5px 0;
                    }
                    .no-print {
                    display: none;
                    }
                </style>
                </head>
                <body onload="window.print(); setTimeout(() => window.close(), 100);">
                ${content}
                </body>
            </html>
            `);

            printWindow.document.close();
        },
        printDivThermal(){
            const divToPrint = document.getElementById('divToPrintThermale');
            var popupWin = window.open('', '_blank', 'width=300,height=300');
            // const widths = 30;
            // const widths = this.cprinter;
            const email = this.infoEntreprise?.email ?? '';
            const phone = this.infoEntreprise?.telephone ?? '';
            const adresse = this.infoEntreprise?.adresse ?? '';
            const logo = (this.infoEntreprise?.logo)?this.infoEntreprise?.logo:'';
            const entreprise = this.infoEntreprise?.nom ?? '';
        //     popupWin.document.open();
        //    popupWin.document.write('<html><header> <div style="width:100%; text-align:center;"> <img style="width:80%; margin-right:20%;" src="/assets/images/'+logo+'" alt="..." class=""> </div> <div style="text-align: center; width:80%;">'+adresse+'</br>'+email+'</br>'+phone+' <hr class="hr-4"><br> </div></header><body onload="window.print()">' + divToPrint.innerHTML + '</body></html>');
        //     popupWin.document.close();
            

            popupWin.document.open();
        popupWin.document.write('<html><head> <title>' + entreprise + '</title></head><header style="width:100%"><div style="width:100%; text-align:center;">' 
        + (logo ? `<img style="width:250px;" src="/assets/images/${logo}" alt="">` : `<span><center><strong><h1>${entreprise}</h1></strong></center></span>`) + '</div> <br><div style="text-align:center; width:100%;">'
        + adresse + '</br>' + email + '</br>' + phone + ' <hr class="hr-4"><br> </div></header><body onload="window.print()">' 
        + divToPrint.innerHTML + '</body><footer style="position:absolute;bottom:0; text-align:center;"><div> <small> Merci d\'avoir choisi' 
        +' '+ entreprise + '</small> </div></footer></html>');
        popupWin.document.close();
        },
        printDivBureau2() {
            console.log('printdivBureau');
            
            const printContents = document.getElementById('divToPrintBureau').innerHTML;
            const originalContents = document.body.innerHTML;

            document.body.innerHTML = printContents;
            window.print();
            document.body.innerHTML = originalContents;
            window.location.reload(); // Recharge pour restaurer l'état initial
        },
        printDivBureau(){
        var divToPrint = document.getElementById('divToPrintBureau');
        var popupWin = window.open('', '_blank', 'width=300,height=300');
        // const widths = 30;
        const widths = this.cprinter ?? '';   
        const email = this.infoEntreprise?.email ?? '';
        const phone = this.infoEntreprise?.telephone ?? '';
        const adresse = this.infoEntreprise?.adresse ?? '';
        const entreprise = this.infoEntreprise?.nom ?? '';
        const logo = '';
        popupWin.document.open();
       popupWin.document.write('<html><head> <title>' + entreprise + '</title></head><header style="float:left; width:100%"><div style="width:100%; text-align:center;">' 
    + (logo ? `<img style="width:250px;" src="/assets/images/${logo}" alt="">` : `<span><center><strong><h1>${entreprise}</h1></strong></center></span>`) + '</div> <br><div style="text-align:center; width:100%;">'
    + adresse + '</br>' + email + '</br>' + phone + ' <hr class="hr-4"><br> </div></header><body onload="window.print()">' 
    + divToPrint.innerHTML + '</body><footer style="position:absolute;bottom:0; text-align:center;"><div> <small> Merci d\'avoir choisi' 
    + ' '+entreprise + '</small> </div></footer></html>');

        popupWin.document.close();
        // var mywindow = window.open('', 'PRINT','');

        // mywindow.document.write('<html><body >');
        // mywindow.document.write(document.getElementById('divToPrint').innerHTML);
        // mywindow.document.write('</body></html>');

        // mywindow.document.close(); // necessary for IE >= 10
        // mywindow.focus(); // necessary for IE >= 10*/ 

        // mywindow.print();
        // mywindow.close();
        },
        Entreprise(){
        axios.get(`${base_url}/getInfoEntreprise`,{
                headers:{
                    Accept:'application/json',
                    'Content-Type':'application/json;charset=UTF-8',
                    Authorization:`Bearer ${this.accessToken}`
                }
            })
        .then((response)=>{
            console.log('Entreprise');
            console.log(response.data.entreprise);
            this.infoEntreprise= response?.data?.entreprise ?? [];
        })
        .catch((error)=>{
            if(error){
            // Gérer d'autres erreurs ici
                console.log();('Une erreur est survenue!');
                console.log('Autre erreur:', error);
            }
        })
    },      
    },
    mounted(){
        this.getDevises();
    }
}
</script>
<style scoped>    
    body { background: #f6f7fb; }
    .app-header { background: #ffffff; border-bottom: 1px solid #eaeaea; }
    .totals-card .list-group-item { border: 0; padding: .5rem 0; }
    .totals-card .label { color: #6c757d; }
    .totals-card .value { font-weight: 600; }
    .cart-table-wrap { max-height: 50vh; overflow: auto; }
</style>